import { memo, useContext } from 'react'

import Box from '@mui/material/Box'
import { FormFieldGenerator, SelectAll } from 'components/shared'
import { OrderContext } from 'context'
import { ContractGenerationDataConsentsFields, ContractGenerationDataFields, IMappedProduct } from 'models'

import { useStepLayoutContext } from '../../../layouts'
import { contractGenerationDataConsentsFieldsProperties } from '../consts'
import { useGetOrderVerifyCustomer } from '../../api'

interface DataConsentsProps {
  orderProductsData: IMappedProduct[]
}

const DataConsents = memo(({ orderProductsData }: DataConsentsProps) => {
  const { contextData, order } = useContext(OrderContext)
  const { faktoria24M } = useStepLayoutContext()

  const isCreditInformationConsentVisible =
    faktoria24M &&
    order?.numberOfMonthsContracted === 24 && // todo mg to confirm
    !(orderProductsData ?? []).some(i => i.withoutCreditRegistryAdditionalServiceTaken)

  const visibleFields = isCreditInformationConsentVisible
    ? ContractGenerationDataConsentsFields
    : {
      selectAll: ContractGenerationDataConsentsFields.selectAll,
      agreementAdministrator: ContractGenerationDataConsentsFields.agreementAdministrator,
      agreementContractor: ContractGenerationDataConsentsFields.agreementContractor
    }

  const {
    data: verifyCustomerData
  } = useGetOrderVerifyCustomer(order?.externalId ?? '')

  return (
    <Box>
      <SelectAll fields={visibleFields} />

      <Box ml={2.4} mt={1.6}>
        {Object.entries(contractGenerationDataConsentsFieldsProperties(
          contextData.isLoan,
          isCreditInformationConsentVisible,
          verifyCustomerData?.externalRequestType === 'ceidg')
        ).map(([key, el]) => (
          <Box key={key} mb={1.6}>
            <FormFieldGenerator fieldName={key as ContractGenerationDataFields} properties={el} />
          </Box>
        ))}
      </Box>
    </Box>
  )
})

export default DataConsents
